import React from 'react'
import {navigate, RouteComponentProps} from '@reach/router'
import {Building} from 'react-bootstrap-icons'
import qs from 'query-string'

import {Loader, Page, Container} from '../layout'
import {useApi} from '../../api/rest'
import {useAuth} from '../../contexts/UserContext'
import OrderItem from './OrderItem'

export default function OrderHistory({location}: RouteComponentProps) {
  const {company} = useAuth()

  const {token} = qs.parse(location?.search || '')
  if (token) {
    navigate(`/verslun/pantanir/${token}/`, {replace: true})
  }

  const {
    data: ordersData,
    isValidating: ordersIsLoading,
  } = useApi(`/orders/?company=${company?.id}`)

  if (ordersIsLoading) {
    return <Loader page />
  }

  return (
    <Page>
      <Container size="lg">
        <div className="py-5">
          <div className="d-flex align-items-center justify-content-between mb-5">
            <h1 className="mb-0">Pöntunarsaga</h1>
            <h4 className="text-muted mb-0">
              <Building size={20} className="mr-3" />
              {company?.name}
            </h4>
          </div>

          <div className="row mb-2">
            {!!ordersData && ordersData.map((order: any, index: number) => (
              <div key={index} className="col-12 col-md-6 col-xl-4 mb-4">
                <OrderItem order={order} />
              </div>
            ))}
          </div>
        </div>
      </Container>
    </Page>
  )
}
